export const CardTitleType = {
  IGetCardTitleService: Symbol("IGetCardTitleService"),
};
